import classNames from 'classnames';
import { Search } from 'lucide-react';
import React from 'react';
import { theme } from 'styles/theme/theme';
import UDInput from 'ud-form/components/input/component';
import Label from 'ud-ui/components/label';
import { DivProps } from 'typings';

interface UDSearchInputProps extends Omit<DivProps, 'placeholder' | 'onChange' | 'onBlur' | 'onSubmit'> {
  value?: string;
  placeholder?: string;
  /** Подпись над полем. Без неё поле рисуется без подписи. */
  label?: string;
  /** С какой стороны стоит лупа. По умолчанию справа. */
  iconPosition?: 'icon-left' | 'icon-right';
  onChange?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  onSubmit?: (value: string) => void;
  parser?: (value: string) => string;

  width?: string;
  backgroundColor?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
}

function UDSearchInput(props: UDSearchInputProps) {
  const {
    value,
    placeholder,
    label,
    iconPosition = 'icon-right',
    onChange,
    width,
    backgroundColor,
    inputRef,
    onBlur,
    autoFocus,
    onSubmit,
    parser,
    ...rest
  } = props;

  const input = (
    <UDInput
      autoFocus={autoFocus}
      style={{ backgroundColor, width: '100%' }}
      value={value}
      placeholder={placeholder}
      parser={parser}
      iconProps={{
        position: iconPosition,
        component: <Search size={16} color={theme.colors.SurfaceRomanSilver30} />,
      }}
      onChange={onChange}
      onSubmit={(event) => onSubmit?.(event.currentTarget.value)}
      onBlur={(event) => onBlur?.(event)}
      ref={inputRef}
    />
  );

  return (
    <div className={classNames('flex items-center justify-between')} {...rest}>
      <div style={{ width: width ? width : '100%' }}>{label ? <Label text={label}>{input}</Label> : input}</div>
    </div>
  );
}

export default UDSearchInput;
